import { useQuestionizerStore } from "../types/state.ts";
import Radio from "./radio.tsx";
import Toggle from "./toggle.tsx";

export default function InputAltbauNeubau (props: {
	id: number, 
  label?: string,
	label_altbau?: string,
	label_neubau?: string,
	icon_altbau: string, 
	icon_altbau_active?: string, 
	icon_neubau: string, 
	icon_neubau_active?: string, 
  onBlur?: ()=>void
}){
  const typ = useQuestionizerStore((state) => state.typ);
  const setTyp = useQuestionizerStore((state) => state.setTyp);
  const updateValidation = useQuestionizerStore((state) => state.updateValidation);

  const label_altbau =  props.label_altbau || useQuestionizerStore((state) => state.E('input-altbau-neubau--altbau'));
  const label_neubau =  props.label_neubau || useQuestionizerStore((state) => state.E('input-altbau-neubau--neubau'));

  return <fieldset className={"section-altbau-neubau section__inputs section__inputs--grid mb-8 input-"+props.id}>
        <legend>{props.label}</legend>
        <div className="sm:hidden md:block sm:col-span-2 hidden lg:block"></div>
        <Radio name="altbauneubau" id={props.id+"-ab"} label={label_altbau} icon={props.icon_altbau} icon_active={props.icon_altbau_active} value={typ == "Altbau"} onBlur={props.onBlur} onChange={(_)=>{
          setTyp("Altbau");
          updateValidation();   
        }}/>
        <Radio name="altbauneubau" id={props.id+"-nb"} label={label_neubau} icon={props.icon_neubau} icon_active={props.icon_neubau_active} value={typ == "Neubau"} onBlur={props.onBlur} onChange={(_)=>{
          setTyp("Neubau");       
          updateValidation();
        }}/>
    </fieldset>
}